import { extendTheme } from "@chakra-ui/react";

const config = {
  initialColorMode: "light",
  useSystemColorMode: false,
  cssVarPrefix: "chakra",
};

const theme = extendTheme({
  config,
  colors: {
    light: {
      bg: "gray.50",
      text: "gray.800",
    },
    dark: {
      bg: "gray.800",
      text: "white",
    },
  },
  styles: {
    global: (props) => ({
      "html, body": {
        bg: props.colorMode === "dark" ? "gray.800" : "gray.50",
        color: props.colorMode === "dark" ? "white" : "gray.800",
      },
    }),
  },
  components: {
    Box: {
      baseStyle: (props) => ({
        bg: props.colorMode === "dark" ? "gray.800" : "gray.50",
        color: props.colorMode === "dark" ? "white" : "gray.800",
      }),
    },
  },
});

export default theme;
